// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  text: 'This is development environment',
  XBASE_URL: 'https://kms02.net:9922',
  BASE_URL: 'https://kms02.net:9922',
  //    XBASE_URL: 'http://192.168.1.5:9922',
  // BASE_URL: 'http://192.168.1.5:9922',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
